import React from "react";
import useTranslate from "./hooks/use-translate";
import { useIntl } from "react-intl";
import { Helmet } from "react-helmet";

const Meta = () => {
  const _t = useTranslate();
  const currentLanguage = useIntl().locale;

  return (
    <Helmet htmlAttributes={{ lang: currentLanguage }}>
      <title>{_t("helmet.title")}</title>
      <meta name="description" content={_t("helmet.meta_description")} />
    </Helmet>
  );
};

export default Meta;
